import { defineComponent as _defineComponent } from 'vue'
import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useBreakpoint from '@/composables/useBreakpoint'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GuidedQuizRegisterModal',
  props: {
    bundlePrefix: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  const { windowOpenProxyCheck } = useCommonMixin()
  const { isMobileDevice } = useBreakpoint()

  

  const redirectToCustomRegistration = () => {
    const isInIframe = (window as any).self !== (window as any).top

    if (isInIframe) {
      ;(window as any).top.postMessage(
        {
          action: 'navigate',
          url: `https://sachkunde.ketchup.academy/registrierung?fromEmbeddedQuiz=${props.bundlePrefix}`,
        },
        '*',
      )
    } else {
      windowOpenProxyCheck(
        `http://localhost:3000/registrierung?fromEmbeddedQuiz=${props.bundlePrefix}`,
        'embedded_guided_quiz_signup_intent',
      )
    }
  }

return { __sfc: true,windowOpenProxyCheck, isMobileDevice, props, redirectToCustomRegistration, KetchUpButton, useCommonMixin, useBreakpoint }
}

})